<ng-container [ngSwitch]="startComponent">
  <app-room-reservation *ngSwitchCase="'room'"></app-room-reservation>
  <app-device-reservation *ngSwitchCase="'device'"></app-device-reservation>

  <div class="container" *ngSwitchDefault>
    <p class="alert alert-danger" role="alert">error in appconfig</p>
  </div>
</ng-container>